<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="#56C0EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 6.5 1 10 4.5 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path><text x="12" y="14.5" fill="currentColor" stroke="none" font-size="7" font-weight="700" text-anchor="middle" font-family="inherit">10</text></svg>
</template>

<script>
export default {
  name: 'IconReplay10'
}
</script>
